// Composant invisible qui pousse un event 'pageview' dans le dataLayer GTM
// a chaque changement de route (SPA navigation)

import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'
import { useEntreprise } from '../../contexts/EntrepriseContext'
import { trackPageView } from '../../lib/analytics'

const PAGE_TITLES: Record<string, string> = {
  '/': 'accueil',
  '/dashboard': 'tableau de bord',
  '/dashboard/plan-action': 'plan actions prevention',
  '/dashboard/attestation': 'attestations',
  '/diagnostic/nouveau': 'selection des metiers',
}

// Titres lisibles pour document.title (avec accents et majuscules)
const DISPLAY_TITLES: Record<string, string> = {
  'accueil': 'Accueil',
  'tableau de bord': 'Tableau de bord',
  'plan actions prevention': 'Plan d\u2019actions pr\u00e9vention',
  'attestations': 'Attestations',
  'selection des metiers': 'S\u00e9lection des m\u00e9tiers',
  'situations de travail': 'Situations de travail',
  'questionnaire risques generaux': 'Questionnaire risques g\u00e9n\u00e9raux',
  'questionnaire risques metiers': 'Questionnaire risques m\u00e9tiers',
  'synthese intermediaire': 'Synth\u00e8se interm\u00e9diaire',
  'resultats du diagnostic': 'R\u00e9sultats du diagnostic',
  'analyse detaillee': 'Analyse d\u00e9taill\u00e9e',
  'niveau de prevention': 'Niveau de pr\u00e9vention',
  'choix des themes prioritaires': 'Choix des th\u00e8mes prioritaires',
  'catalogue solutions prevention': 'Catalogue solutions pr\u00e9vention',
  'finalisation du diagnostic': 'Finalisation du diagnostic',
  'synthese finale du diagnostic': 'Synth\u00e8se finale du diagnostic',
  'attestation de niveau': 'Attestation de niveau',
  'admin attestation detail': 'Admin - D\u00e9tail attestation',
  'admin attestations': 'Admin - Attestations',
  'plan action detail': 'D\u00e9tail plan d\u2019actions',
}

function getPageTitle(pathname: string): string {
  if (PAGE_TITLES[pathname]) return PAGE_TITLES[pathname]
  // Routes dynamiques (:id)
  if (pathname.match(/\/diagnostic\/[^/]+\/q1/)) return 'questionnaire risques generaux'
  if (pathname.match(/\/diagnostic\/[^/]+\/q2/)) return 'questionnaire risques metiers'
  if (pathname.match(/\/diagnostic\/[^/]+\/situations/)) return 'situations de travail'
  if (pathname.match(/\/diagnostic\/[^/]+\/synthese-finale/)) return 'synthese finale du diagnostic'
  if (pathname.match(/\/diagnostic\/[^/]+\/synthese-2/)) return 'analyse detaillee'
  if (pathname.match(/\/diagnostic\/[^/]+\/synthese/)) return 'synthese intermediaire'
  if (pathname.match(/\/diagnostic\/[^/]+\/resultats/)) return 'resultats du diagnostic'
  if (pathname.match(/\/diagnostic\/[^/]+\/casques/)) return 'niveau de prevention'
  if (pathname.match(/\/diagnostic\/[^/]+\/themes/)) return 'choix des themes prioritaires'
  if (pathname.match(/\/diagnostic\/[^/]+\/solutions/)) return 'catalogue solutions prevention'
  if (pathname.match(/\/diagnostic\/[^/]+\/finalisation/)) return 'finalisation du diagnostic'
  if (pathname.match(/\/diagnostic\/[^/]+\/actions/)) return 'plan actions prevention'
  if (pathname.match(/\/diagnostic\/[^/]+\/attestation/)) return 'attestation de niveau'
  if (pathname.match(/\/admin\/attestations\/[^/]+/)) return 'admin attestation detail'
  if (pathname.match(/\/admin\/attestations/)) return 'admin attestations'
  if (pathname.match(/\/dashboard\/plan-action\/[^/]+/)) return 'plan action detail'
  return 'page inconnue'
}

export function PageViewTracker() {
  const location = useLocation()
  const { user, isLoading } = useAuth()
  const { currentNumEservice } = useEntreprise()
  const previousUrl = useRef(document.referrer || '')

  useEffect(() => {
    if (isLoading) return

    const currentUrl = window.location.origin + location.pathname

    const gaTitle = getPageTitle(location.pathname)

    trackPageView({
      loginStatus: user ? 'oui' : 'non',
      userId: currentNumEservice || '',
      contactId: user?.numEservice || '',
      previousUrl: previousUrl.current,
      pageUrl: currentUrl,
      pageTitle: gaTitle,
    })

    // Mettre a jour le titre de l'onglet navigateur (sauf accueil → garder le title SEO)
    if (location.pathname !== '/') {
      const displayTitle = DISPLAY_TITLES[gaTitle] || gaTitle
      document.title = `Diag SCOP Pr\u00e9vention - ${displayTitle}`
    }

    previousUrl.current = currentUrl
  }, [location.pathname, user, isLoading, currentNumEservice])

  return null
}
